module.exports = "/v2/pages/dashboard/dist/a1a749e89f578a49306ec2b055c073da.svg";